import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  referAndEarnContainer: {
    height: 'calc(100vh - 136px)',
    overflow: 'auto',
  },
  mainHeader: {},
  mainHeaderText: {
    // marginLeft: 15,
    fontSize: 29,
    color: theme.palette.warning.contrastText,
    marginBottom: 30,
    fontWeight: 700,
    letterSpacing: 0.3,
    '@media (max-width: 525px)': {
      fontSize: 20,
      marginBottom: 20,
    },
  },
  referAndEarnWorkingContainer: {
    background: theme.palette.common.white,
    borderRadius: '11px',
    boxShadow: theme.shadows[3],
    padding: '20px 40px',
    '@media (max-width: 620px)': {
      padding: '15px 5%',
    },
  },
  headerWorkingText: {
    textAlign: 'center',
    fontSize: 20,
    color: theme.palette.grey[50],
    marginBottom: 15,
    fontWeight: 700,
    letterSpacing: 0.3,
    lineHeight: '30px',
    '@media (max-width: 525px)': {
      fontSize: 17.5,
      lineHeight: '22px',
    },
  },
  workingText: {
    fontSize: 15,
    color: theme.palette.grey[500],
    fontWeight: 400,
    letterSpacing: 0.3,
    maxWidth: 840,
    margin: 'auto auto 20px',
    textAlign: 'center',
    lineHeight: '26px',
    '@media (max-width: 525px)': {
      fontSize: 15,
      lineHeight: '22px',
    },
  },
  inviteIconBox: {
    height: 60,
    width: 60,
    background: '#F6F8FB',
    boxShadow: theme.shadows[5],
    borderRadius: 50,
    marginBottom: 15,
    display: 'flex',
  },
  smallIcon: {
    margin: 'auto',
  },
  inviteMainText: {
    fontSize: 18,
    color: theme.palette.grey[50],
    marginBottom: 5,
    fontWeight: 700,
    letterSpacing: 0.3,
    lineHeight: '30px',
  },
  inviteSubText: {
    fontSize: 15,
    color: theme.palette.grey[50],
    marginBottom: 15,
    fontWeight: 400,
    letterSpacing: 0.3,
    maxWidth: 200,
    textAlign: 'center',
    lineHeight: '24px',
    '@media (max-width: 525px)': {
      maxWidth: '100%',
    },
  },
  referInviteBox: {
    maxWidth: 812,
    margin: '20px auto auto',
  },
  referralDataContainer: {
    marginTop: 20,
    background: theme.palette.common.white,
    borderRadius: 20,
    boxShadow: theme.shadows[1],
    padding: 0,
    overflow: 'hidden',
    '@media (max-width: 525px)': {
      // padding: '15px 25px',
    },
  },
  errorMessage: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.error.main,
  },
  loader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  noRecordText: {
    color: theme.palette.grey[600],
    fontSize: 15,
    letterSpacing: 0.3,
    textAlign: 'center',
  },
  // table
  tableContainer: {
    maxHeight: '300px',
    overflow: 'overlay',
    paddingBottom: 15,
    '& .MuiTableCell-body': {
      // padding: 15,
    },
  },
  theadBox: {
    background: theme.palette.grey[800],
    '& .MuiTableCell-head': {
      background: theme.palette.grey[800],
      lineHeight: '16px',
      borderRadius: 0,
      '&:first-child': {
        borderRadius: '20px 0 0 0',
      },
      '&:last-child': {
        borderRadius: '0 20px 0 0',
      },
    },
  },
  tBodyStatus: {
    color: '#EA7445',
  },
  resendInviteBtn: {
    fontSize: 11,
    fontWeight: 600,
    color: '#EA7445',
    background: 'transparent',
    border: '1px solid #EA7445',
    height: 30,
    width: 90,
    textTransform: 'capitalize',
  },
}));
